import styled from 'styled-components';
import AntdModal from '../../../AntdModal';
import {typographyStyles} from '../../../../utils/styles';

const StyledRequestPaymentModal = styled(AntdModal)`
  .ant-modal-content {
    .ant-modal-body {
      ${typographyStyles.body.regular};
    }
    .ant-modal-footer {
      display: flex;
      justify-content: flex-end;
      .ant-btn {
        .ant-btn-icon {
          display: flex;
        }
        &:disabled {
          svg {
            path {
              fill: rgba(0,0,0,0.25);
            }
          }
        }
        svg {
          path {
            fill: ${props => props.theme.colors.neutral_1};
          }
        }
      }
    }
  }
`;

const StyledRequestPaymentModalDate = styled.div`
  ${typographyStyles.footnote.description};
  color: ${props => props.theme.colors.neutral_7};
`;

const StyledRequestPaymentModalVendor = styled.div`
  ${typographyStyles.footnote.description};
  color: ${props => props.theme.colors.neutral_10};
`;

const StyledRequestPaymentModalAmount = styled.div`
  ${typographyStyles.heading.h4};
  color: ${props => props.theme.colors.neutral_10};
`;

export {
  StyledRequestPaymentModal,
  StyledRequestPaymentModalDate,
  StyledRequestPaymentModalVendor,
  StyledRequestPaymentModalAmount
};
